var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000488281,
    width: 24.0001,
    height: 23.9991,
    rx: 11.9995,
    fill: "#FF3939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9609 14.4766V4.47656C10.9609 3.81382 11.4984 3.27637 12.1611 3.27637C12.8239 3.27637 13.3613 3.81382 13.3613 4.47656V14.4766C13.3613 15.1393 12.8239 15.6768 12.1611 15.6768C11.4984 15.6768 10.9609 15.1393 10.9609 14.4766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1611 20.0771C11.4984 20.0771 10.9609 19.5397 10.9609 18.877C10.9609 18.2558 11.4332 17.7452 12.0381 17.6836L12.1611 17.6768C12.8239 17.6768 13.3613 18.2142 13.3613 18.877C13.3613 19.4982 12.8891 20.0087 12.2842 20.0703L12.1611 20.0771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.c830a2112480408fb793cdc5b1fd879a.svg";
export { ForwardRef as ReactComponent };